// extracted by mini-css-extract-plugin
module.exports = {"FormTitle":"SelectPortal_FormTitle_1Tlg2","Message":"SelectPortal_Message_1is8g"};